import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { newTherapyTemplateAction, therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_SINGLE_MDS_ASSESSMENT_REQUEST,
  GET_SINGLE_MDS_ASSESSMENT_SUCCESS,
  GET_SINGLE_MDS_ASSESSMENT_FAILURE,
  GET_SINGLE_MDS_ASSESSMENT_LOADING,
  GET_SINGLE_MDS_ASSESSMENT_RESET,
} = therapyPlanningAction;

function* getSingleMdsAssessment(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_SINGLE_MDS_ASSESSMENT_LOADING });

    const reponse = yield call(therapyPlanningService.getSingleMdsAssessment, payload.payload);
    if (reponse?.status === 200) {
      yield put({
        type: GET_SINGLE_MDS_ASSESSMENT_SUCCESS,
        payload: reponse?.data,
      });
    } else throw reponse.data;
  } catch (error) {
    yield put({ type: GET_SINGLE_MDS_ASSESSMENT_FAILURE, payload: error });
  }
}

function* getSingleMdsAssessmentSaga() {
  yield takeEvery(GET_SINGLE_MDS_ASSESSMENT_REQUEST, getSingleMdsAssessment);
}

export default getSingleMdsAssessmentSaga;
